import { componentClassName } from '@/styles/Heading';
import { StandaloneHeading } from 'base/components/Heading';
import { withSafeInnerHTML } from 'lib/utils';
import mergeProps from 'lib/utils/mergeProps';

export const AllasStandaloneHeading: typeof StandaloneHeading = ({ content, tag, options, ...props }) => {
  const Component = tag ?? 'h2';
  const className = componentClassName('', {});

  return <Component {...mergeProps({ className }, options as any)} {...props} {...withSafeInnerHTML(content)} />;
};

export default AllasStandaloneHeading;
